"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentRadio = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _v = _interopRequireDefault(require("uuid/v4"));
var _Radio = require("../../../../../../../../ui/Radio");
var _styles = _interopRequireDefault(require("./styles"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Label = _styledComponents.default.label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", " !important;\n"])), function (props) {
  return props.highlighted ? props.theme.primaryColor : undefined;
});
var PaymentRadioPure = function PaymentRadioPure(_ref) {
  var icon = _ref.icon,
    title = _ref.title,
    description = _ref.description,
    checked = _ref.checked,
    value = _ref.value,
    onChange = _ref.onChange;
  var _useRef = (0, _react.useRef)((0, _v.default)()),
    id = _useRef.current;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_styles.default.root, _defineProperty({}, _styles.default.checked, checked))
  }, /*#__PURE__*/_react.default.createElement(_Radio.Radio, {
    id: id,
    icon: icon,
    className: _styles.default.radio,
    iconClassName: _styles.default.radioIcon,
    description: description,
    checked: checked,
    value: value,
    onChange: onChange
  }), /*#__PURE__*/_react.default.createElement(Label, {
    highlighted: checked,
    className: (0, _classnames3.default)(_styles.default.body, _defineProperty({}, _styles.default.hasIcon, icon)),
    htmlFor: id
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.title
  }, title), description && /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.description
  }, description), icon && /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.icon,
    dangerouslySetInnerHTML: {
      __html: icon
    }
  })));
};
PaymentRadioPure.propTypes = {
  title: _propTypes.default.string.isRequired,
  checked: _propTypes.default.bool.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onChange: _propTypes.default.func.isRequired,
  icon: _propTypes.default.string,
  description: _propTypes.default.string
};
var PaymentRadio = exports.PaymentRadio = (0, _react.memo)(PaymentRadioPure);